import React, {useEffect, useState} from 'react';
import {Map as GoogleMap, Marker, useMap, useMapsLibrary} from "@vis.gl/react-google-maps";
import MapControls from "../../../../components/map-report/map-buttons-control.jsx";
import {mapStyles} from "../../../../utils/map-styles.js";

const IndividualAlarmMap = ({id, markers, initialPos}) => {
    const map = useMap();
    const coreLib = useMapsLibrary("core");

    const [mapState, setMapState] = useState({neighborhoodStreets: false, pointsOfInterest: true});

    useEffect(() => {
        if (!map || !coreLib || !markers?.length) return;

        if (markers.length > 1) {
            const bounds = new coreLib.LatLngBounds();
            markers.forEach(marker => bounds.extend(new coreLib.LatLng(marker.lat, marker.lng)));
            map.fitBounds(bounds);
        } else {
            map.setCenter(new coreLib.LatLng(markers[0]?.lat, markers[0]?.lng));
        }
    }, [map, markers, coreLib]);

    return (
        <GoogleMap
            reuseMaps={true}
            defaultZoom={16}
            styles={mapStyles(mapState)}
            mapTypeControl={false}
            streetViewControl={false}
            defaultCenter={markers.length > 0 ? {lat: 0, lng: 0} : initialPos}
            gestureHandling={"cooperative"}
            disableDefaultUI={true}
            zoomControl={true}
            style={{height: "100%"}}
        >
            {
                markers.map((marker, i) => (
                    <Marker
                        key={`marker-${id}-${i}`}
                        position={{lat: parseFloat(marker.lat), lng: parseFloat(marker.lng)}}
                    />
                ))
            }

            <MapControls
                mapState={mapState}
                onTogglePOI={() => setMapState(prev => ({...prev, pointsOfInterest: !prev.pointsOfInterest}))}
                onToggleNeighborhood={() => setMapState(prev => ({...prev, neighborhoodStreets: !prev.neighborhoodStreets}))}
            />
        </GoogleMap>
    );
};

export default IndividualAlarmMap;
